import { useMemo } from 'react';

import type { PreparedWorkload } from 'features/workload-optimization/types';

import {
  hasError,
  hasLowConfidence,
  isAppliedWithPods,
  isStopped,
} from '../../../_workloadStatusUtils';

export const useStatusColumnWidth = (workloads: PreparedWorkload[]) => {
  return useMemo(() => {
    let widestStatus = 90;

    for (const workload of workloads) {
      let status = 32; // paddings
      if (hasLowConfidence(workload) || hasError(workload)) {
        status += 36;
      }

      if (isAppliedWithPods(workload)) {
        // width to fit 999/999
        status += 132;
      }

      if (isStopped(workload)) {
        status += 90;
      }

      widestStatus = Math.max(widestStatus, status);
    }

    return widestStatus;
  }, [workloads]);
};
